import { apiClient } from './api-client';

export const validationApi = {
  listByLangAndStatus: async (
    lang: string,
    status: 'pending' | 'accepted' | 'rejected',
    page = 1,
    limit = 10,
  ) => {
    const { data } = await apiClient.get(
      `/validation/lang/${encodeURIComponent(lang)}/status/${encodeURIComponent(status)}`,
      { params: { page, limit } },
    );

    return {
      ...data,
      items: Array.isArray(data?.items) ? data.items : Array.isArray(data?.data) ? data.data : [],
    };
  },

  getSasUrl: async (blobName: string): Promise<string> => {
    const base = import.meta.env.VITE_API_URL?.replace(/\/$/, '') || '';
    const url = `${base}/audio/${encodeURIComponent(blobName)}/sas`;
    const { data } = await apiClient.get(url);
    return data.sasUrl;
  },

  validateAudio: async (payload: {
    audioId: string | number;
    action: 'accept' | 'reject';
    correctedLanguage?: string;
    audioGender?: string;
    reason?: string;
  }) => {
    const { data } = await apiClient.post(
      `/validation/${encodeURIComponent(String(payload.audioId))}/validate`,
      {
        action: payload.action,
        ...(payload.correctedLanguage && { correctedLanguage: payload.correctedLanguage }),
        ...(payload.audioGender && { audioGender: payload.audioGender }),
        ...(payload.reason && { reason: payload.reason }),
      },
    );
    return data;
  },
};

